<script>
    import { mapGetters } from 'vuex'
    import Title from './title'
    import QrCounter from './qrCounter'
    import Stock from './stock'
    import Inventory from './inventory'
    import PendingInventory from './pendingInventory'
    import { inventoryMethods } from '@state/helpers'
    
    export default {
      name: 'CountInventory',
      components: { Title, QrCounter, Stock, Inventory, PendingInventory },
      data() {
        return {
        }
      },
      computed: {
        ...mapGetters({
            own_inventory_count_mode: 'retina/inventory/own_inventory_count_mode',
            own_inventory: 'retina/inventory/own_inventory',
          own_total_products: 'retina/inventory/own_total_products',
          own_total_products_quantity: 'retina/inventory/own_total_products_quantity',
          own_stock: 'retina/inventory/own_stock',
          own_total_stock: 'retina/inventory/own_total_stock',
          own_total_stock_quantity: 'retina/inventory/own_total_stock_quantity',
          own_pending: 'retina/inventory/own_pending',
          own_total_pending: 'retina/inventory/own_total_pending',
          own_total_pending_quantity: 'retina/inventory/own_total_pending_quantity',
        }),
      },
      methods: {
        ...inventoryMethods,
        sumQuantityItems(items){
          let quantity = 0
          for (let i = 0; i < items.length; i++) {
            const item = items[i];
            if ('batchs' in item){
              let subquantity = 0
              for (let b = 0; b < item.batchs.length; b++) {
                subquantity += item.batchs[b].quantity;
              }
              quantity += subquantity
            }
          }
          return quantity
        },
      },
      mounted() {
        const _total_pending_quantity = this.sumQuantityItems(this.own_pending)
        if (_total_pending_quantity !== this.own_total_pending_quantity){
          // console.log("distintos!", this.total_pending_quantity, '!==', _total_pending_quantity)
          this.setOwnTotalPendingQuantity(_total_pending_quantity)
        }
      },
    }
    </script>
    
    <template>
      <div v-if="own_inventory_count_mode">
        <div class="row mb-1">
          <div class="col-md-12 col-xl-6">
            <Title />
          </div>
          <div class="col-md-12 col-xl-6">
            <QrCounter />
          </div>
        </div>
    
        <div>
          <b-tabs id="menu-tabs"  active-nav-item-class="font-weight-bold text-blue" 
            nav-class="text-center" content-class="bg-white">
            <b-tab active title-link-class="m-0 px-1 py-2 font-weight-light">
              <template #title>
                <i class="fas fa-dolly-flatbed mr-1 fa-lg"></i>
                <br>
                <strong>Conteo </strong>
                <b-badge :variant="own_total_stock_quantity ? 'blue' : 'light'">{{ own_total_stock_quantity }}</b-badge>
              </template>
              <Stock />
            </b-tab>
            <!--<b-tab title-link-class="m-0 px-1 py-2 font-weight-light">
              <template #title>
                <i class="fas fa-warehouse mr-1 fa-lg"></i>
                <br>
                <strong>Existencias </strong>
                <b-badge :variant="own_total_products_quantity ? 'blue' : 'light'">{{ own_total_products_quantity ? own_total_products_quantity : 0  }}</b-badge>
              </template>
              <Inventory />
            </b-tab>
            <b-tab title-link-class="m-0 px-1 py-2 font-weight-light">
              <template #title>
                <i class="fas fa-bell mr-1 fa-lg"></i>
                <br>
                <strong>Pendientes</strong>
                <b-badge :variant="total_pending_quantity ? 'blue' : 'light'">{{ total_pending_quantity ? total_pending_quantity : 0  }}</b-badge>
              </template>
              <PendingInventory />
            </b-tab>-->
          </b-tabs>
        </div>
      </div>
    </template>
    <style lang="scss">
    @media screen and (max-width: 765px) {
      #menu-tabs .nav-item {
        width: 33.3333%;
      }
    }
    @media screen and (min-width: 766px) {
      #menu-tabs .nav-item {
        min-width: 110px;
      }
    }
    </style>